import { ReactElement } from 'react';
import { ProductsAnalyticsProvider } from '@client/analytics/context/products/ProductsAnalyticsContext';
import { EVENT_SOURCE } from '@client/analytics/types/types';
import { StandaloneViewPageContainer } from './StandaloneViewPageContainer';

const StandaloneViewPage = (): ReactElement => (
  <ProductsAnalyticsProvider eventSource={EVENT_SOURCE.wishlist}>
    <StandaloneViewPageContainer />
  </ProductsAnalyticsProvider>
);

export { StandaloneViewPage };
export default StandaloneViewPage;
